export default __webpack_public_path__ + "static/media/pearl-3.2e65a52f.png";